import { Injectable } from '@angular/core';
import { ActionService, AuthService, CarrierService, CatalogSyncService, CategoryService, CmsService, CountryService, EnvironmentConfigService, InvoiceService, NotesService, OrderReportService, OrdersService, ProductService, ReportService, ResourceService, ShopService, StatusService, TasksService, UserService } from './api/services';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    public auth: AuthService,
    public action: ActionService,
    public carrier: CarrierService,
    public category: CategoryService,
    public cms: CmsService,
    public product: ProductService,
    public env: EnvironmentConfigService,
    public shop: ShopService,
    public status: StatusService,
    public resource: ResourceService,
    public user: UserService,
    public report: ReportService,
    public catalog: CatalogSyncService,
    public orderReport: OrderReportService,
    public country: CountryService,
    public order: OrdersService,
    public notes: NotesService,
    public tasks: TasksService,
    public invoice: InvoiceService,
  ) { }

}
